import { Icon } from 'components/Icon';
import { estiloAlerta, piorAlerta } from 'utils/alertas';

// O icone de alerta na coluna Id, compartilhado pelas telas do menu Cobranca.
// Mesmo motivo do `historyAction.js`: os alertas sao do contrato e do cliente,
// e nao mudam conforme o degrau da esteira em que ele esta sendo olhado.
//
// O icone leva ao modal da coluna Historico, que e onde os alertas sao lidos
// e encerrados. O espaco dele fica reservado em todas as linhas: sem isso o id
// das linhas com alerta desalinha das demais.
//
// `children` e o conteudo da celula ao lado do icone — o id puro, ou o id com
// os marcadores de renegociacao, como faz a Cobranca.
export const AlertIdCell = ({ row, setModal, reload, children }) => {
  const alerta = piorAlerta(row?.alertas);
  const estilo = estiloAlerta(alerta?.nivel);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
      <span style={{ width: '18px', flexShrink: 0, display: 'inline-flex' }}>
        {alerta ? (
          <Icon
            name={estilo.icone}
            size={18}
            color={estilo.cor}
            onClick={() => {
              setModal({ type: 'historico_cobranca', dados: row, reload });
            }}
            elementAttributes={{
              title: (row?.alertas || [])
                .map((item) => `• ${item?.mensagem}`)
                .join('\n'),
              style: { cursor: 'pointer' },
            }}
          />
        ) : null}
      </span>
      {children}
    </span>
  );
};

// Para as telas em que o Id nao tem nada alem do numero. A tela faz o spread:
//
//   overrides: { ...buildAlertIdOverride({ setModal, reload }) }
export const buildAlertIdOverride = ({ setModal, reload }) => ({
  id: {
    renderCell: ({ row }) => (
      <AlertIdCell row={row} setModal={setModal} reload={reload}>
        {row?.id}
      </AlertIdCell>
    ),
  },
});
